/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios'
import { API_ENDPOINTS } from 'Constants'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getDashboardDetails: ( {startDate , endDate,userid} ) => {
    return axios.get(API_ENDPOINTS.DASHBOARD, {
      headers: {
        isAuthRequired: true,
        'Content-Type': 'application/json',
      },
      params: {
        startDate, // Query parameter for start date
        endDate,   // Query parameter for end date
      },
    });
  },
  getChartData: ({ userid, months }) => {
    return axios.get(API_ENDPOINTS.DASHBOARD_CHART, {
      headers: {
        isAuthRequired: true,
        'Content-Type': 'application/json',
      },
      params: {
        userid,
        months,
      },
    });
  },
}
